// Keep browser detection independent of React and atoms: UI atoms use it during initialization.
export function getWebWindow() {
  return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window : undefined;
}
